import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function LockedOut() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(50); // Countdown timer in seconds

  useEffect(() => {
    // If countdown reaches 0, redirect to login page
    if (countdown === 0) {
      navigate('/login');  // Redirect to login page
    }

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [countdown, navigate]);

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      {/* Lockout Image */}
      <img 
        src="/icons/locked.jpg"  // Path to the locked image
        alt="Locked Out"
        style={{ width: '300px', height: 'auto', marginBottom: '20px' }} 
      />

      <h1>Your account has been locked due to multiple failed login attempts.</h1>
      <p>Please wait {countdown} seconds before trying again.</p>
    </div>
  );
}

export default LockedOut;
